module.exports = __webpack_public_path__ + "img/zhaomu.ff6e627a.png";